module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxs2Ua5FNUHV5nolPhplIfzg.woff2";